import gql from 'graphql-tag';
const WHACK_A_MOLE_ACTIVITY_FRAGMENT = gql `
  fragment WhackAMoleActivityFragment on WhackAMoleActivity {
    rounds {
      id
      numTimesShuffled
      sentence
      syllableGroups
      syllables
      word
    }
  }
`;
export default WHACK_A_MOLE_ACTIVITY_FRAGMENT;
